export default {
    when() {
        return document.querySelectorAll('#video-home').length > 0;
    },

    mounted() {
        let videoHome = document.querySelector('#video-home');
        let button = document.querySelector('.video-button');
        function playPause() {
            if (videoHome.paused) {
                videoHome.play();
                button.classList.add('opacity-0');
            } else {
                videoHome.pause();
                button.classList.remove('opacity-0');
            }
        }

        
        videoHome.addEventListener('click', () => {
            playPause();
        });
        button.addEventListener('click', () => {
            playPause();
        });
    },
};
